module.exports = __webpack_public_path__ + "media/src/assets/images/content/save-your-mobile-e02f047bbabb87f2c208fc7cb40f855f.png";